import { profile, axiosConfig } from 'api';

import { BillingCompany, GetAllBillingCompanyResponse } from 'models/billingCompany';
import { Response } from 'models/response';

export const getAllBillingCompanies = (companyId: string, status?: boolean): Promise<GetAllBillingCompanyResponse[]> =>
  profile
    .get(`/Company/GetAllBillingCompanies/${companyId}${status ? `/${status}` : ''}`, axiosConfig)
    .then((response) => response.data);

export const saveBillingCompany = async (billingCompany, companyId): Promise<BillingCompany> => {
  try {
    if (billingCompany.companyId) {
      return await (
        await profile.put<Response<BillingCompany>>(`/Company/UpdateBillingCompany/${companyId}`, {
          ...billingCompany,
          companyId: undefined,
          billingCompanyId: billingCompany.companyId,
        })
      ).data.data;
    } else {
      return await (
        await profile.post<Response<any>>('/Company/CreateBillingCompany', { ...billingCompany, companyId: companyId })
      ).data.data;
    }
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const activateOrDesactivateBillingCompany = async (
  companyId: string,
  billingCompanyId,
  isActive,
): Promise<boolean> => {
  if (isActive) {
    return profile
      .put(`/Company/AddBillingCompany/${companyId}`, {
        billingCompanyId: billingCompanyId,
      })
      .then((response) => response.data.data);
  } else {
    return profile
      .delete(`/Company/DeleteBillingCompany/${companyId}`, {
        data: { billingCompanyId: billingCompanyId },
      })
      .then((response) => response.data.data);
  }
};
